import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import axios from 'axios';
import global from './mixins/global';

import WithTheMenu from './layouts/WithTheMenu.vue';
Vue.component('WithTheMenu', WithTheMenu);

Vue.config.productionTip = false;
Vue.prototype.$axios = axios;
Vue.mixin(global);

axios.defaults.baseURL = process.env.VUE_APP_BASE_URL


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
